import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WalletRechargeComponent from '../../components/payments/WalletRechargeComponent';
import MainLayout from '../../layouts/MainLayout';

const MockWalletRecharge = () => {
  const authState = useSelector(state => state.authReducer);
  const [showWalletRechargeModal, setShowWalletRechargeModal] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(null); // State to store the selected wallet amount
  const loggedInUserName = authState.user.name;

  // Function to handle the selection of wallet amount
  const handleAmountSelection = (amount) => {
    setSelectedAmount(amount);
    setShowWalletRechargeModal(true); // Open the PaymentComponent modal when amount is selected
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Mock Wallet Recharge</h2>
      </div>
      <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
      {!showWalletRechargeModal && (
        <div className="flex flex-wrap">
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(100)}>Rs. 100</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(200)}>Rs. 200.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(250)}>Rs. 250.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(500)}>Rs. 500.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(1000)}>Rs. 1000.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(5000)}>Rs. 5000.00</button>
          <button className='ml-5 w-2/12 my-2' onClick={() => handleAmountSelection(10000)}>Rs. 10,000.00</button>
        </div>
        )}
        {showWalletRechargeModal && <WalletRechargeComponent onClose={() => setShowWalletRechargeModal(false)} loggedInUserName={loggedInUserName} selectedAmount={selectedAmount} />}
      </div>
    </MainLayout>
  );
};

export default MockWalletRecharge;
